// extracted by mini-css-extract-plugin
export default {"header-wrapper":"styles_header-wrapper__GOLci","header":"styles_header__m-oRC","header__burger-icon":"styles_header__burger-icon__iP6Eu"};